export const COLOR_OUTDOOR = '#009036';
export const COLOR_SUPPLY = '#0064b3';
export const COLOR_EXTRACT = '#ffe600';
export const COLOR_EXHAUST = '#945c06';
